import React from "react";

const Home = () => {
  return (
    <div><h1>Surgery IS website</h1>
  
   <h2> <a href = 'https://athenaweb.uphs.upenn.edu'>Help desk</a></h2>
</div>

  )
};

export default Home;
